import { useColorScheme } from '@mui/joy';
import { ReactNode, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { Header, LeftMenu } from 'core/components';
import { ModeType } from 'theme/enums';

import { PageContentWrapper, PageRightWrapper, PageWrapper } from './pageLayoutStyle';

interface IProps {
  children?: ReactNode;
  hasGlobalSearch?: boolean;
  hasSwitchVersion?: boolean;
  scrollable?: boolean;
  title?: string;
}

const PageLayout = ({
  children,
  hasGlobalSearch = true,
  hasSwitchVersion = false,
  scrollable = false,
  title,
}: IProps) => {
  const { mode } = useColorScheme();

  useEffect(() => {
    const agThemeMode = mode === ModeType.DARK ? 'dark' : 'light';

    document.documentElement.setAttribute('data-ag-theme-mode', agThemeMode);
  }, [mode]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <PageWrapper>
        <LeftMenu />

        <PageRightWrapper>
          <Header hasSwitchVersion={hasSwitchVersion} hasGlobalSearch={hasGlobalSearch} />

          <PageContentWrapper scrollable={scrollable}>{children}</PageContentWrapper>
        </PageRightWrapper>
      </PageWrapper>
    </HelmetProvider>
  );
};

export default PageLayout;
